import { render } from "./FormSinester.vue?vue&type=template&id=3b2242b0"
import script from "./FormSinester.vue?vue&type=script&lang=js"
export * from "./FormSinester.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__